import { ArrowUpRight, Gift } from "lucide-react";
import { Link } from "react-router-dom";
import { useMyInvite } from "@/hooks/useMyInvite";

/** Referral entry stays above the account avatar, outside the scrolling navigation. */
export function SidebarShareJoylo({ linkState }: { linkState?: unknown }) {
  const { invite } = useMyInvite();
  const reward = invite?.referrer_bonus_credits ?? 300;
  const available = invite?.is_active !== false && reward > 0;

  return (
    <Link
      to="/referrals"
      state={linkState}
      title={available ? `Earn ${reward} credits after your friend pays for a $25/month or higher plan` : "View your referrals"}
      className="group mb-3 mt-3 block rounded-[10px] border border-plum/50 bg-canvas px-3 py-3 text-left transition-colors hover:border-plum hover:bg-selected focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-plum/40"
    >
      <span className="flex items-center gap-2">
        <span className="grid h-6 w-6 shrink-0 place-items-center rounded-md bg-selected text-plum">
          <Gift aria-hidden="true" className="h-3.5 w-3.5" />
        </span>
        <span className="flex-1 text-[13px] font-medium text-foreground">Share Joylo</span>
        <ArrowUpRight aria-hidden="true" className="h-3.5 w-3.5 shrink-0 text-muted-foreground transition-colors group-hover:text-plum" />
      </span>
      <span className="mt-2 block text-[11px] leading-[17px] text-muted-foreground">
        {available ? <><span className="font-semibold text-plum">Earn {reward} credits</span> per referral</> : "View your referrals"}
      </span>
    </Link>
  );
}
